import { Button } from 'components/UI/Button/Button';
import React from 'react';
import { useSelector } from 'react-redux';
import { getOnlineBookingPreferences } from 'reducers/marketplace/MarketplaceSelectors';
import { OnlineBookingPricingOptions } from 'types/OnlineBooking';
import { getOnlineBookingTotalAmount } from 'reducers/onlineBooking/OnlineBookingSelectors';

interface OnlineBookingFooterProps {
    label?: string;
    loading?: boolean;
    disabled?: boolean;
    onSubmit: () => void;
}

export const OnlineBookingFooter: React.FC<OnlineBookingFooterProps> = ({
    label,
    disabled,
    loading,
    onSubmit
}) => {
    const onlineBookingPreferences = useSelector(getOnlineBookingPreferences);

    const totalAmount = useSelector(getOnlineBookingTotalAmount);

    const shouldShowTotal = React.useMemo(() => {
        // return ![
        //     OnlineBookingStep.Home,
        //     OnlineBookingStep.Signup,
        //     OnlineBookingStep.Signin
        // ].includes(currentStep);

        return false;
    }, []);

    return (
        <div className="flex flex-col gap-2">
            {shouldShowTotal && (
                <p className="text-base flex items-center justify-between">
                    {onlineBookingPreferences.pricingOption ===
                    OnlineBookingPricingOptions.StartingAt
                        ? 'Starting at'
                        : 'Price'}
                    <span className="font-medium">${totalAmount.toFixed(2)}</span>
                </p>
            )}

            <Button fullWidth disabled={disabled} loading={loading} onClick={onSubmit}>
                {label ?? 'Continue'}
            </Button>
        </div>
    );
};
